export const cachingSlice = ((set, get) => ({

  actions: {
     storeItem: (key, elm)=>{
       let item = JSON.stringify(elm);
       localStorage.setItem('desca-'+key, item);
     },
     retrieveItem: (key)=>{
       let item = localStorage.getItem('desca-'+key);
       return JSON.parse(item);
     }
  }

}))